import React from 'react';

function Home() {
  return (
    <>
      <div className="homesection">
        <h2>Welcome to our Page</h2>
        <p className="content-paragraph">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam iure  reprehenderit.
          Animi maxime iure dolor molestiae, aliquam blanditiis voluptatibus veritatis quae quia
          ipsa!
          At reiciendis.
          Minima sint labore sed debitis sunt error iste dolor ullam blanditiis, minus nihil.
          Voluptates at.
          Minima sint labore sed debitis sunt error iste dolor ullam blanditiis, minus nihil.
          Voluptates at.
          Minima sint labore sed debitis sunt error iste dolor ullam blanditiis, minus nihil.
          Voluptates at., tempora tempore ex.
          Non iste obcaecati doloremque hic tenetur iusto, modi ab sunt soluta velit. , illum velit?
        </p>
      </div>
    </>
  );
}

export default Home;
